import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 90rem;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(180deg, #1c1d1f 0%, #0f0f10 100%);
`;
